import { Colon, TimePart, TimeWrapper } from "styledComponents/timesheet";

export const HmsDisplay = ({ timeString }) => {
  if (!timeString || timeString === "-") {
    return <TimeWrapper>-</TimeWrapper>;
  }

  const hasHours = timeString.includes("h");
  const hasMinutes = timeString.includes("m");
  const hasSeconds = timeString.includes("s");

  const parts = timeString.split(" ");
  const hoursPart = hasHours ? parseInt(parts.find(p => p.includes("h"))) : 0;
  const minutesPart = hasMinutes ? parseInt(parts.find(p => p.includes("m"))) : 0;
  const secondsPart = hasSeconds ? parseInt(parts.find(p => p.includes("s"))) : 0;

  return (
    <TimeWrapper>
      <TimePart >{hoursPart}</TimePart>
      <Colon>:</Colon>
      <TimePart >{minutesPart}</TimePart>
      <Colon>:</Colon>
      <TimePart >{secondsPart}</TimePart>
    </TimeWrapper>
  );
};